/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftStatusMutationRequest, PostApiBarberShiftStatusMutationResponse, PostApiBarberShiftStatus400, PostApiBarberShiftStatus401, PostApiBarberShiftStatus403, PostApiBarberShiftStatus404, PostApiBarberShiftStatus500 } from "../entities/PostApiBarberShiftStatus";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBarberShiftStatus } from "../api/postApiBarberShiftStatus";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBarberShiftStatusMutationKey = () => [{ url: '/api/barber/shift/status' }] as const

export type PostApiBarberShiftStatusMutationKey = ReturnType<typeof postApiBarberShiftStatusMutationKey>

export function postApiBarberShiftStatusMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostApiBarberShiftStatusMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postApiBarberShiftStatusMutationKey()
        return mutationOptions<PostApiBarberShiftStatusMutationResponse, ResponseErrorConfig<PostApiBarberShiftStatus400 | PostApiBarberShiftStatus401 | PostApiBarberShiftStatus403 | PostApiBarberShiftStatus404 | PostApiBarberShiftStatus500>, {data: PostApiBarberShiftStatusMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return postApiBarberShiftStatus(data, config)
          },
        })

}

/**
 * @description Изменение статуса (свободен/занят/перерыв)
 * @summary Изменить статус мастера
 * {@link /api/barber/shift/status}
 */
export function usePostApiBarberShiftStatus<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBarberShiftStatusMutationResponse, ResponseErrorConfig<PostApiBarberShiftStatus400 | PostApiBarberShiftStatus401 | PostApiBarberShiftStatus403 | PostApiBarberShiftStatus404 | PostApiBarberShiftStatus500>, {data: PostApiBarberShiftStatusMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostApiBarberShiftStatusMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBarberShiftStatusMutationKey()

          const baseOptions = postApiBarberShiftStatusMutationOptions(config) as UseMutationOptions<PostApiBarberShiftStatusMutationResponse, ResponseErrorConfig<PostApiBarberShiftStatus400 | PostApiBarberShiftStatus401 | PostApiBarberShiftStatus403 | PostApiBarberShiftStatus404 | PostApiBarberShiftStatus500>, {data: PostApiBarberShiftStatusMutationRequest}, TContext>
          

          return useMutation<PostApiBarberShiftStatusMutationResponse, ResponseErrorConfig<PostApiBarberShiftStatus400 | PostApiBarberShiftStatus401 | PostApiBarberShiftStatus403 | PostApiBarberShiftStatus404 | PostApiBarberShiftStatus500>, {data: PostApiBarberShiftStatusMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBarberShiftStatusMutationResponse, ResponseErrorConfig<PostApiBarberShiftStatus400 | PostApiBarberShiftStatus401 | PostApiBarberShiftStatus403 | PostApiBarberShiftStatus404 | PostApiBarberShiftStatus500>, {data: PostApiBarberShiftStatusMutationRequest}, TContext>
      
}